<template>
  <div>
    <nav class="d-flex justify-content-between align-items-center bg-dark p-2 px-4">
      <div class="navbar-brand">
        <svg data-v-5a6ee65f="" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 953 953" width="32" height="32"
          version="1.1" shape-rendering="geometricPrecision" fill-rule="evenodd" clip-rule="evenodd" focusable="false"
          role="img" class="d-block">
          <title data-v-5a6ee65f="">BootstrapVue</title>
          <path data-v-5a6ee65f="" fill="currentColor"
            d="M92 0h769c50 0 92 42 92 92v769c0 50-42 92-92 92H92c-50 0-92-42-92-92V92C0 42 42 0 92 0zm216 710c100 0 160-50 160-133 0-62-44-107-108-113v-3c48-8 86-52 86-102 0-71-55-117-140-117H111v468h197zM195 307h90c50 0 78 23 78 64 0 44-33 68-91 68h-77V307zm0 338V499h90c64 0 98 25 98 73s-33 73-94 73h-94zm503 65l163-468h-90L652 621h-2L531 242h-92l163 468h96z">
          </path>
        </svg>
      </div>
      <div>
        <input type="text" value="pretty malfunction" class="form-control form-control-sm bg-dark border-0 greyColor" />
      </div>
      <div class="d-flex align-items-center buttonSection">
        <div class="redoUndobtn mr-4">
          <a class="greyColor noanchor cursor-pointer mr-3"  @click="undoCav()"><i
              class="fa-solid fa-rotate-left"></i></a>
          <a class="greyColor noanchor cursor-pointer mr-3" @click="redoCav()"><i
              class="fa-solid fa-rotate-right"></i></a>
        </div>
        <div>
          <a @click="setScreendisplay('horizontal')"
            :class="`greyColor noanchor ${selectedResolution === '16:9' || selectedResolution === '1920x1080'? 'active' : null }`"><i
              class="fa-solid fa-display"></i></a>
          <a @click="setScreendisplay('vertical')"
            :class="`greyColor noanchor mx-2 ${selectedResolution === '1080x1920' ? 'active' : null }`"><i
              class="fa-solid fa-mobile-screen-button"></i></a>
          <a class="greyColor noanchor  smallFont" @click="$bvModal.show('Resolution-modal')">{{resolutionValue}} <i
              class="fa-solid fa-angle-down"></i></a>


        </div>

      </div>
      <div>
        <button class="btn btn-light btn-icon btn-xs" @click="setZoomOut"><i class="fas fa-minus"></i></button>
        <b-dropdown id="dropdown-1" class="m-0" variant="link" toggle-class="text-decoration-none" no-caret>
          <template #button-content>
            <a class="greyColor noanchor smallFont">{{widthPercentage}}% <i class="fa-solid fa-angle-down"></i></a>
          </template>
          <!-- <b-dropdown-item @click="setZoomIn">Zoom in</b-dropdown-item>
          <b-dropdown-item @click="setZoomOut">Zoom out</b-dropdown-item> -->
          <b-dropdown-item @click="setZoomtoFit">Zoom to fit</b-dropdown-item>
          <b-dropdown-item @click="setZoomto50">Zoom to 50%</b-dropdown-item>
          <b-dropdown-item @click="setZoomto100">Zoom to 100%</b-dropdown-item>
          <b-dropdown-item @click="setZoomto200">Zoom to 200%</b-dropdown-item>

        </b-dropdown>
        <button class="btn btn-light btn-icon btn-xs"  @click="setZoomIn"><i class="fas fa-plus"></i></button>
      </div>
      <div class="d-flex align-items-center">
        <b-dropdown id="dropdown-1" class="m-0" variant="link" toggle-class="text-decoration-none" no-caret>
          <template #button-content>
            <a class="greyColor noanchor mr-4"><i class="fa-solid fa-cloud-arrow-down"></i></a>
          </template>
          <!-- <b-dropdown-item @click="downloadDivAsImage">PNG</b-dropdown-item> -->
          <b-dropdown-item @click="captureScreenshot">PNG</b-dropdown-item>
          <b-dropdown-item @click="setZoomto50">SVG</b-dropdown-item>
          <b-dropdown-item @click="captureMP4">MP4</b-dropdown-item>

        </b-dropdown>
        <!-- <a class="greyColor noanchor mr-4"><i class="fa-solid fa-cloud-arrow-down"></i></a> -->
        <a class="greyColor noanchor mr-4 cancelbtn">Cancel</a>
        <a class="btn btn-light mr-3 PreviewBtn" @click="$bvModal.show('Preview-modal')">Preview</a>
        <a class="btn btn-light mr-3" @click="savePreset">Save Preset</a>
        <a class="btn btn-secondary">Save & Close</a>
      </div>
    </nav>
    <div>

      <b-modal id="Resolution-modal" hide-header>
        <!-- <template #modal-title>
      Using <code>$bvModal</code> Methods
    </template> -->
        <div class="d-block text-center">
          <h4 class="text-center mb-3">Switch Resolution</h4>

          <select class="form-control" name="Resolutiontype" id="select-resolution" @change="onChange($event)"
            v-model="selectedResolution">
            <option value="16:9">16:9 Horizontal</option>
            <option value="1080x1920">1080x1920 Vertical</option>
            <option value="1920x1080">1920x1080 Full HD</option>
            <option value="3840x2160">3840x2160 4k UHD</option>
            <option value="custom">Custom</option>
          </select>

          <div class="row mt-3" v-if="showCustomResolution">
            <div class="col-md-6">
              <div class="form-group">
                <label> WIDTH (PX)</label>
                <input type="text" @change="(e) => this.customWidth = e.target.value"
                  class="form-control text-center" />
              </div>
            </div>
            <div class="col-md-6">
              <div class="form-group">
                <label> HEIGHT (PX)</label>
                <input type="text" @change="(e) => this.customHeight = e.target.value"
                  class="form-control text-center" />
              </div>
            </div>
          </div>
        </div>
        <template #modal-footer>
          <button class="btn btn-secondary" @click="$bvModal.hide('Resolution-modal')">Close Me</button>
          <button class="btn btn-primary" @click="setCanvasSize">Switch</button>

        </template>
      </b-modal>
      <b-modal size="lg" id="Preview-modal" header-class="border-0" @hidden="handleModalClosed" @shown="handleModalOpened">
        <template #modal-header>
          <div class="customheader">
            <div class="cross">
                     <button  @click="$bvModal.hide('Preview-modal')" class="button" variant="light">
                      <span>
                        <i class=" text fa-solid fa-xmark"></i>
                      </span>
                     </button>
            </div>
          </div>
          </template>
       <PreviewCanvas :activeSlide="activeSlide" v-on:updateSliderMaxValue="updateSliderMaxValue" :maxSliderValue="maxSliderValue" :slider-value="sliderValue" v-on:update-slider-value="updateSliderValue" :isPlayAnimation="isPlayAnimation" :isvisiblemodal="isvisiblemodal" />
       
        <template #modal-footer>

          <div class="previewSlider_bottomBar p-2">
            <div class="d-flex align-items-center justtify-content-between">
              <div class="slides_menu d-flex align-items-center justtify-content-between ">
                <i class="fa fa-angle-left font-22 text-white pointer"></i> 
                <div class="selectionMenu px-3">
                  <select name="" id="" @change="changeSlide($event)" :value="activeSlide" class="form-control form-control-sm">
                    <option v-for="(item,index) in getallCanvas" v-bind:key="item.id" :value="index">Slide {{ index + 1 }}</option>
                  </select>
                </div> 
                <i class="fa fa-angle-right font-22 text-white pointer"></i> 
              </div>
              <div class="divider"></div>
              <div class="select_oriantation">
                <select name="" id="" class="form-control form-control-sm">
                    <option value="L">Landscape</option>
                    <option value="V">Vertical</option>
                </select>
              </div>
              <div class="divider"></div>
              <div class="video_controls d-flex align-items-center flex-grow-1">
                <i v-if="isPlayAnimation === true" @click="playPauseAnimation(false)" class="fa fa-stop pr-2 font-22 text-white pointer"></i>
                <i v-if="isPlayAnimation === false" @click="playPauseAnimation(true)" class="fa fa-play playBtn pr-2 font-22 text-white pointer"></i>
               <div class="px-2 w-100">
                <input type="range" :max="maxSliderValue" v-model="sliderValue" class="video_duration form-control form-control-range px-0" >
               </div>
                <span class="timeStamp " ><span class="text-white">{{numberToDuration(sliderValue)}}</span>/{{numberToDuration(maxSliderValue)}}</span>
              </div>
              <div class="divider"></div>
              <div class="fullScreen">
                <i class="fa fa-expand font-22 text-white pointer"></i> 
              </div>
            </div>
          </div>
        </template>
      </b-modal>
    </div>
  </div>

</template>

<script>
// import { drawGrid, removeGrid } from "../common"
import html2canvas from 'html2canvas';
import axios from "axios";
import PreviewCanvas from "../Canvas/PreviewCanvas.vue"
import {getResolutionScaleValue} from "../common";

export default {
  data() {
    return {
      selectedResolution: "16:9",
      resolutionValue: "16:9",
      showCustomResolution: false,
      zoom: "40",
      customWidth: "",
      customHeight: "",
      zoomLevel: 1,
      canvasWidth: 600,
      canvasheight: 400,
      isvisiblemodal : false,
      zoomRatio: 1,
      isPlayAnimation:false,
      sliderValue: 0,
      maxSliderValue: 100,
      activeSlide:0,
    };
  },
  components:{
    PreviewCanvas
  },
  name: 'TopNavbar',
  props: {
    msg: String,
    view: String
  },
 
  computed: {
    zoomValue() {
      return this.$store.getters.getZoom
    },
    getallCanvas(){
      return this.$store.getters.getCanvasInstances
    },
    getCurrentActiveCanvas() {
      return this.$store.getters.getCurrentActiveCanvas
    },
    getCurrentActiveSize() {
      return this.$store.getters.getCurrentActiveSize
    },
    changeData() {
      let size = this.$store.getters.getCurrentActiveSize;
      return size
    },
    getActiveCanvasObjectsList() {
            return this.$store.getters.getCurrentActiveCanvasObjects
     },
    widthPercentage(){
      

      let zoom = this.$store.getters.getZoom;
      let size = this.$store.getters.getCurrentActiveSize;
      var element = document.querySelector('.CanvasWrapper');
      let width = 0;
      if(element){
        var Celement = window.getComputedStyle(element, null);

        var paddingX = parseFloat(Celement.paddingLeft) + parseFloat(Celement.paddingRight);


        let parentWidth = element.offsetWidth - paddingX;
         width = (size.width * zoom) / parentWidth * 100;

      }
      return parseInt(width)

    }
  },
  watch: {
    zoomValue: {
      handler: function (val) {
        

        let canvas = this.getCurrentActiveCanvas;
        if (val > 0.26) {
          this.drawGrid(canvas)
        } else {
          console.log("removeGrid")
          this.removeGrid(canvas)
        }
      },
      deep: true
    }
  },
  mounted(){
    this.setZoomtoFit();
  },
  methods: {
    changeSlide(e){
      let value = e.target.value;
this.activeSlide = value;
    },
     numberToDuration(seconds) {
      // Ensure seconds is a non-negative integer
      if (seconds < 0) {
        throw new Error('Input must be a non-negative integer.');
      }

      // Calculate minutes and remaining seconds
      const minutes = Math.floor(seconds / 60);
      const remainingSeconds = seconds % 60;

      // Format minutes and seconds with leading zeros if necessary
      const formattedMinutes = String(minutes).padStart(2, '0');
      const formattedSeconds = String(remainingSeconds).padStart(2, '0');

      // Return duration in the format "mm:ss"
      return `${formattedMinutes}:${formattedSeconds}`;
    },
    updateSliderValue(value){
      console.log("test" , value)
      this.sliderValue = value ;
    },
    updateSliderMaxValue(value){
      console.log("testing va" , value)
      this.maxSliderValue = value ;
    },
    playPauseAnimation(value){
      this.isPlayAnimation = value
    },
    handleModalOpened(){
      this.isvisiblemodal = true;
      this.$store.dispatch("setActiveObject", null)
    },
    handleModalClosed(){
      this.isvisiblemodal = false;
    },
    drawGrid(canvas){
      console.log(canvas)
      
     let element =  document.querySelector("#" + canvas.id);
     element.style.backgroundImage = `linear-gradient(white 30%, transparent 1px), linear-gradient(to right, white 30%, transparent 1px), linear-gradient(to right, rgb(160, 177, 245) 1px, transparent 1px), linear-gradient(rgb(160, 177, 245) 1px, transparent 1px), linear-gradient(rgb(236, 239, 253) 1px, transparent 1px), linear-gradient(to right, rgb(236, 239, 253) 1px, transparent 1px)`;
     element.style.backgroundSize = `1% 3.2%, 3.2% 1%, 25% 25%, 25% 25%, 6.25% 6.25%, 6.25% 6.25%`;
     element.style.backgroundPosition = `-1px -1px`;
    },
    removeGrid(canvas){
      console.log(canvas)

      let element =  document.querySelector("#" + canvas.id);
     element.style.backgroundImage = "";
     element.style.backgroundSize = "";
     element.style.backgroundPosition = "";
      

    },
    undoCav() {
      

				this.$store.dispatch("undo");
			},
			redoCav() {
        this.$store.dispatch("redo");

			},
    setScreendisplay(value) {
      // this.$store.dispatch("setZoom",1)
      if (value === "horizontal") {
        // this.$store.dispatch("setCurrentCanvasDimensions", { width: this.getWrapperDimension()?.width , height: this.getWrapperDimension()?.height })
        this.$store.dispatch("setCurrentCanvasDimensions", { width: 1920 , height: 1080 })
        this.selectedResolution = "16:9";
        this.resolutionValue = "16:9";
        // this.$store.dispatch("setZoom",.4)
        this.$store.dispatch("setZoom",getResolutionScaleValue(1920,1080))
      } else {
        this.setVerticalSize();
      }
    },
    onChange(e) {
      e.target.value === "custom" ? this.showCustomResolution = true : this.showCustomResolution = false;
    },
    setVerticalSize() {
      this.selectedResolution = "1080x1920";
      this.resolutionValue = "1080x1920";
      // this.$store.dispatch("setCurrentCanvasDimensions", { width: this.getWrapperDimension()?.width / 2, height: this.getWrapperDimension()?.height })
      this.$store.dispatch("setCurrentCanvasDimensions", { width: 1080, height: 1920 });
     
      this.$store.dispatch("setZoom",getResolutionScaleValue(1080,1920))
    },
    setCanvasSize() {
      
      debugger // eslint-disable-line no-debugger
      if (this.showCustomResolution === true) {
        if (this.customWidth != "" && this.customHeight != "") {
         
        
          this.$store.dispatch("setCurrentCanvasDimensions", { width: parseInt(this.customWidth), height: parseInt(this.customHeight) })
          this.selectedResolution = 'custom'
          this.resolutionValue = `${parseInt(this.customWidth)}x${parseInt(this.customHeight)}`
          this.$store.dispatch("setZoom",getResolutionScaleValue(parseInt(this.customWidth),parseInt(this.customHeight)))
        }

      } else {
        if(this.selectedResolution == "16:9" || this.selectedResolution == "1920x1080"){
          this.selectedResolution = "1920x1080";
          this.resolutionValue = "1920x1080";
          this.$store.dispatch("setCurrentCanvasDimensions", { width: parseInt(1920), height: parseInt(1080) })

          this.$store.dispatch("setZoom",getResolutionScaleValue(1920,1080))
          // this.setZoomtoFit();
        } else if(this.selectedResolution == "1080x1920"){
          this.setVerticalSize();

        } else {
          // this.GetCanvasAtResoution(3840)
         
          this.$store.dispatch("setCurrentCanvasDimensions", { width: parseInt(3840), height: parseInt(2160) })
          this.selectedResolution = `${parseInt(3840)}x${parseInt(2160)}`;
          this.resolutionValue = `${parseInt(3840)}x${parseInt(2160)}`;
          this.$store.dispatch("setZoom",getResolutionScaleValue(3840,2160))

        }

      }
      this.$bvModal.hide('Resolution-modal')



    },
    setZoomIn() {
      let canvas = this.getCurrentActiveCanvas;
      if (canvas) {
        this.$store.dispatch("setZoom", this.zoomValue +0.1)
      }
    },
    setZoomOut() {
      let canvas = this.getCurrentActiveCanvas;
      if (canvas) {
        this.$store.dispatch("setZoom", this.zoomValue - 0.1)
      }
    },
    setZoomtoFit() {
      debugger // eslint-disable-line no-debugger

       let canvas = this.getCurrentActiveCanvas;
    

      this.$store.dispatch("setZoom", getResolutionScaleValue(canvas.size.width,canvas.size.height))

      
    },
    setZoomto50() {
      this.zoomToFixNum(.5)

    },
    setZoomto100() {
      this.zoomToFixNum(1.5)

    },
    setZoomto200() {
      this.zoomToFixNum(2)
    },
    zoomToFixNum(value) {
      let canvas = this.getCurrentActiveCanvas;
      if (canvas) {
        this.$store.dispatch("setZoom", value)
      }
    },
    // getResolutionScaleValue(width,height){
    //   debugger // eslint-disable-line no-debugger
    //   // if(height > width){
    //   //   let ratio = width/height;
    //   //   let ParentHeight = document.querySelector(".canvas-box").parentElement.offsetHeight;
    //   //   let newWidth = ratio * ParentHeight ;
    //   //   let newwidths = newWidth / width;
    //   //   return Number(newwidths.toFixed(2)) - 0.02
    //   // } else {
    //   //   let ratio = height/width;
    //   //   let ParentWidth = document.querySelector(".canvas-box").parentElement.offsetWidth;
    //   //   let newWidth = ratio * ParentWidth ;
    //   //   let newwidths = newWidth / height;
    //   //   return Number(newwidths.toFixed(2)) - 0.04
    //   // }

    //   const parentElement = document.querySelector(".canvas-box")?.parentElement;
    // const ParentWidth = parentElement?.offsetWidth || 0;
    // const ParentHeight = parentElement?.offsetHeight || 0;
  
    // // Calculate the maximum scale value ensuring the child stays inside the canvas
    // const scaleX = (ParentWidth - 20) / width;
    // const scaleY = (ParentHeight -30) / height;
    
    // // Use the smaller scale to ensure the child fits within the canvas
    // const scale = Math.min(scaleX, scaleY);
    
    // return scale;
      
    // },
    
    savePreset(){
      console.log("Tariq Brother please copy this :")
      console.log(this.$store.state.activeObjectprops)
    },
    downloadDivAsImage() {
      console.log(this.getCurrentActiveCanvas)
      const divToDownload = document.querySelector("#" + this.getCurrentActiveCanvas.id);

      const options = {
        allowTaint: true,
        useCORS: true,
        logging: false,
      };
   




      html2canvas(divToDownload, {...options}).then((canvas) => {
        const link = document.createElement('a');
        link.download = 'div_image.png';
        link.href = canvas.toDataURL('image/png');
        link.click();
      });
    },
    async captureScreenshot() {
      debugger // eslint-disable-line no-debugger

      let list = this.getActiveCanvasObjectsList;
      let size = this.getCurrentActiveSize;
      let zoom = this.zoomValue;
      try {
        const response = await axios.post(process.env.VUE_APP_SERVER_URL + '/capture-screenshot', { list , size , zoom },{ responseType: 'arraybuffer' });
        
        if (response.status === 200) {
          const screenshotData = response.data;
          console.log(screenshotData)
          // Convert array buffer to Blob
          const screenshotBlob = new Blob([screenshotData], { type: 'image/png' });
          
          // Create a temporary URL for the Blob
          const url = window.URL.createObjectURL(screenshotBlob);
          
          // Create a link element
          const link = document.createElement('a');
          link.href = url;
          link.download = 'screenshot.png'; // Filename for the downloaded file
          
          // Append the link to the document body and trigger the download
          document.body.appendChild(link);
          link.click();
          
          // Cleanup: Remove the link and revoke the URL
          document.body.removeChild(link);
          window.URL.revokeObjectURL(url);
        } else {
          console.error('Error capturing screenshot:', response.statusText);
        }
      } catch (error) {
        console.error('Error capturing screenshot:', error);
      }
    },
    async captureMP4() {
  debugger // eslint-disable-line no-debugger

   let list = this.getActiveCanvasObjectsList;
  let size = this.getCurrentActiveSize;
   let zoom = this.zoomValue;
  
  try {
    const response = await axios.post(process.env.VUE_APP_SERVER_URL + '/capture-video', 
      { duration: this.maxSliderValue, size, frameRate: 24 , list , zoom }, 
      { responseType: 'arraybuffer' } // Expecting binary data as an arraybuffer
    );
    
    if (response.status === 200) {
      const videoData = response.data;

      // Convert the arraybuffer to a Blob
      const blob = new Blob([videoData], { type: 'video/mp4' });

      // Create a URL for the Blob
      const url = URL.createObjectURL(blob);

      // Create a temporary link to trigger the download
      const a = document.createElement('a');
      a.href = url;
      a.download = `video_${Date.now()}.mp4`;
      document.body.appendChild(a);
      a.click();
      
      // Clean up
      URL.revokeObjectURL(url);
      document.body.removeChild(a);

    } else {
      console.error('Error capturing video:', response.statusText);
    }
  } catch (error) {
    console.error('Error capturing video:', error);
  }
}

    // downloadDivAsImage() {
    //   console.log(this.getCurrentActiveCanvas)
    //   const divToDownload = document.querySelector("#" + this.getCurrentActiveCanvas.id);

    //   // const divToDownload = this.$refs.divToDownload;
    //   const { width, height } = divToDownload.getBoundingClientRect();

    //   const svg = `<svg xmlns="http://www.w3.org/2000/svg" width="${width}" height="${height}">
    //                 <foreignObject width="100%" height="100%">
    //                   <div xmlns="http://www.w3.org/1999/xhtml">
    //                     ${divToDownload.innerHTML}
    //                   </div>
    //                 </foreignObject>
    //               </svg>`;

    //   const svgUrl = `data:image/svg+xml;base64,${btoa(unescape(encodeURIComponent(svg)))}`;
    //   const img = new Image();

    //   img.onload = () => {
    //     const canvas = document.createElement('canvas');
    //     canvas.width = width;
    //     canvas.height = height;
    //     const context = canvas.getContext('2d');
    //     context.drawImage(img, 0, 0);

    //     const link = document.createElement('a');
    //     link.download = 'div_image.png';
    //     link.href = canvas.toDataURL('image/png');
    //     link.click();
    //   };

    //   img.src = svgUrl;
    // },
  }
}
</script>


<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
.greyColor {
  color: rgb(197 204 209) !important;
  font-size: 20px;

}

.cancelbtn {
  font-size: 16px;
  font-weight: 600;
}

.fa-angle-down {
  font-size: 12px;
}

.smallFont {
  font-size: 16px;
  font-weight: 600;
}

.greyColor.noanchor.active {
  color: rgb(248 249 250) !important;
  background-color: rgb(73 80 87);
  border-radius: 5px;
  cursor: pointer;
}

.greyColor.noanchor {
  padding: 5px 8px;

}

.greyColor.noanchor.active:hover {
  background-color: rgb(172 181 189);

}
.btn-xs{
  padding: 0.05rem 0.19rem;
    font-size: 10px;
    line-height: 1.5;
    border-radius: 0.2rem;
}
.previewSlider_bottomBar{
  background-color: rgb(53 58 64/1);
  border-radius: 5px;
}
.font-22{
  font-size: 18px;
}
.divider{
  width: 1px;
    height: 26px;
    background: #fff;
    margin: 0px 10px;
}
.pointer{
  cursor: pointer;
}
.timeStamp{
  color:#cfcdcd;
}
.customheader{
 margin-left: 98%;
}
.button{
  border: 1px solid white;
  color: white;
  border-radius: 70%;
  height: 30px;
  width: 30px;
  padding: 1px 1px;
  margin: 0px 0px 0px auto ;
  background: transparent;
  cursor: pointer;
}
.text{
  font-size: 16px;
  font-weight: 700;
}


</style>
